import { r as registerInstance, h, H as Host } from './index-662ec80e.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { a as vString, a1 as vUndefOr, p as vEthereumAddress, S as vOneOf } from './validation-02b8d01d.js';
import { t as tuple } from './types-6f6b2fba.js';
import './i18n-939e2dee.js';

const options = tuple('active', 'inactive');

const dsEthWalletCss = "ds-eth-wallet span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}ds-eth-wallet .status-active::before{margin-left:0.25rem !important;content:\"\\2022\";color:var(--success);font-size:calc(var(--gw) * 2);width:calc(var(--gw) * 1.5);vertical-align:middle}ds-eth-wallet .status-inactive::before{margin-left:0.25rem !important;content:\"\\2022\";color:var(--grey-600);font-size:calc(var(--gw) * 2);width:calc(var(--gw) * 1.5);vertical-align:middle}";

const DsEthWallet = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.propError = {};
    this.name = '-';
    this.wallet = undefined;
    this.status = 'inactive';
  }
  watchName() {
    /* istanbul ignore if */
    if (!propCheck(this, 'name', 'string', vString))
      return;
  }
  watchWallet() {
    /* istanbul ignore if */
    if (!propCheck(this, 'wallet', 'ethereumAddress', vUndefOr(vEthereumAddress)))
      return;
  }
  watchStatus() {
    /* istanbul ignore if */
    if (!propCheck(this, 'status', `'${options.join("', '")}'`, vOneOf(options)))
      return;
  }
  connectedCallback() {
    runWatchers(this);
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    return (h(Host, { class: "_flex:column" }, h("span", { class: "_text:sm" }, this.name, h("span", { class: `status-${this.status}` })), h("span", { class: "_text:sm _text-grey-900" }, this.wallet)));
  }
  static get watchers() { return {
    "name": ["watchName"],
    "wallet": ["watchWallet"],
    "status": ["watchStatus"]
  }; }
};
DsEthWallet.style = dsEthWalletCss;

export { DsEthWallet as ds_eth_wallet };
